export interface ConfirmOpts {
  title?: string;
  name?: string;
  detail?: string;
  confirmText?: string;
  cancelText?: string;
}

interface ConfirmState extends ConfirmOpts {
  open: boolean;
}

let state = $state<ConfirmState>({ open: false });
let resolver: ((v: boolean) => void) | null = null;

export const confirmStore = {
  get state() {
    return state;
  },
  /** Open a themed confirm dialog; resolves true/false. Replaces native confirm(). */
  ask(opts: ConfirmOpts): Promise<boolean> {
    if (resolver) resolver(false);
    state = { open: true, confirmText: 'Confirm', cancelText: 'Cancel', ...opts };
    return new Promise<boolean>((resolve) => {
      resolver = resolve;
    });
  },
  resolve(v: boolean) {
    state = { ...state, open: false };
    resolver?.(v);
    resolver = null;
  },
};

export function confirmDialog(opts: ConfirmOpts): Promise<boolean> {
  return confirmStore.ask(opts);
}
